export default __webpack_public_path__ + "static/media/ic_connect.3df426cf.svg";